export default [
  'square',
  'parallelogram',
  'trapezoid',
  'circle',
  'diamond',
  'triangle',
  'ellipse',
  'star5',
  'star6',
  'star7',
  'star8',
  'rpoly5',
  'rpoly6',
  'rpoly7',
  'rpoly8',
  'gear5',
  'gear6',
  'gear7',
  'gear8',
  'pie',
];
